import { useMemo } from "react";
import type { ExcursionCardProps } from "@op/puck-types";
import { cls, clx } from "@op/utils";

const ExcursionCardWzb = ({
  excursion,
  isMarginal,
  variant,
  scrollId,
  onClick,
}: ExcursionCardProps) => {
  const actualVariant = useMemo(() => {
    switch (variant) {
      case "primary":
        return "brand";
      case "secondary":
        return "brandsecondary";
      case "tertiary":
        return "brandtertiary";
    }
  }, [variant]);

  return (
    <div
      id={scrollId}
      className={cls(
        "cursor-pointer transition-colors w-full",
        clx({
          "h-full": !isMarginal,
          "bg-brand-50 hover:bg-brand-100": actualVariant === "brand",
          "bg-brandsecondary-50 hover:bg-brandsecondary-100":
            actualVariant === "brandsecondary",
          "bg-brandtertiary-50 hover:bg-brandtertiary-100":
            actualVariant === "brandtertiary",
        }),
      )}
      onClick={onClick}
    >
      <div
        className={cls(
          "w-full",
          "h-2",
          "mb-12",
          clx({
            "bg-brand-500": actualVariant === "brand",
            "bg-brandsecondary-500": actualVariant === "brandsecondary",
            "bg-brandtertiary-500": actualVariant === "brandtertiary",
          }),
        )}
      ></div>
      <div className={cls("flex flex-col p-8")}>
        <span
          className={cls(
            "text-caption-bold font-caption-bold comp-excursion-card-title inline-block",
            clx({
              "text-brand-700": actualVariant === "brand",
              "text-brandsecondary-700": actualVariant === "brandsecondary",
              "text-brandtertiary-700": actualVariant === "brandtertiary",
            }),
          )}
        >
          {excursion.overline}
        </span>
        <div
          className={cls(
            "comp-excursion-card-title inline-block text-[24px] leading-[1.2em] font-heading-4",
            clx({
              "!text-brand-700": actualVariant === "brand",
              "!text-brandsecondary-700": actualVariant === "brandsecondary",
              "!text-brandtertiary-700": actualVariant === "brandtertiary",
            }),
          )}
        >
          {excursion.title}
        </div>
      </div>
    </div>
  );
};

export default ExcursionCardWzb;
